import { Badge, Button, Card, CardBody } from "reactstrap"
import ThemePlaceholder from "components/Common/ThemePlaceholder"
import { joinWithSeparator } from "helpers/text_helpers"
import { downloadVehiclePdf } from "helpers/pdf_helper"
import StatusBadge from "components/Common/StatusBadge"
import { useMemo } from "react"
import { generateStockText, generateStockTitle } from "helpers/stock_helpers"
import { CopyButton } from "components/Common/CopyButton"
import LiveIndicator from "components/Common/LiveIndicator/LiveIndicator"
import "./StockView.css"

export default function StockHeader({ stock, loading = false, onAddNewStock }) {
  const onClickDownload = async stockId => {
    try {
      await downloadVehiclePdf(stockId)
    } catch (error) {}
  }

  const summaryText = joinWithSeparator([
    stock?.year?.name,
    stock?.package?.name ? `${stock.package.name} Package` : null,
    stock?.exterior_color?.name,
  ])

  const textToCopy = useMemo(() => generateStockText(stock), [stock])
  const titleText = useMemo(() => generateStockTitle(stock), [stock])

  return (
    <Card className="border-0 shadow-sm overflow-hidden mb-4">
      <div className="stock-profile-card__cover">
        <div className="d-flex justify-content-between align-items-start gap-3 flex-wrap">
          <div>
            {loading ? (
              <ThemePlaceholder
                style={{ width: 260, height: 24, borderRadius: 6 }}
              />
            ) : (
              <div className="d-flex align-items-center flex-wrap gap-2">
                <h4 className="mb-0 fw-semibold text-dark">{titleText}</h4>
                <CopyButton text={textToCopy} />
              </div>
            )}

            {loading ? (
              <ThemePlaceholder
                style={{ width: 180, height: 18, borderRadius: 6, marginTop: 8 }}
              />
            ) : (
              <p className="mb-0 text-muted mt-1">{summaryText || "-"}</p>
            )}

            <div className="d-flex flex-wrap align-items-center gap-2 mt-2">
              <Badge className="badge-soft-primary border-0">
                <i
                  className="fas fa-map-marker-alt me-1"
                  style={{ fontSize: 7 }}
                ></i>
                {stock?.showroom?.name ?? ""} -{" "}
                {stock?.showroom?.short_name ?? ""}
              </Badge>
              {stock?.is_published_on_website && (
                <LiveIndicator text="Live on Website" />
              )}
            </div>
          </div>

          <div className="d-flex gap-2 flex-wrap align-items-center">
            {loading ? (
              <ThemePlaceholder
                style={{ width: 90, height: 24, borderRadius: 6 }}
              />
            ) : (
              <StatusBadge value={stock?.status} />
            )}
            {loading ? (
              <ThemePlaceholder
                style={{ width: 90, height: 24, borderRadius: 6 }}
              />
            ) : (
              <StatusBadge
                trueLabel="Published"
                falseLabel="Draft"
                trueColor="primary"
                falseColor="warning"
                value={stock?.is_published}
              />
            )}
          </div>
        </div>
      </div>

      <CardBody className="p-4">
        <div className="d-flex flex-wrap gap-2">
          <Button size="sm" color="primary" onClick={onAddNewStock}>
            <i className="bx bx-plus me-1" />
            Add New Stock
          </Button>

          <Button
            size="sm"
            color="warning"
            onClick={() =>
              window.open(
                `https://aurobilcars.com/vehicle/${stock?.stock_id}`,
                "_blank"
              )
            }
          >
            <i className="bx bx-link-external me-1" />
            View on Website
          </Button>

          <Button
            size="sm"
            color="info"
            onClick={() => onClickDownload(stock?.full_chassis)}
          >
            <i className="mdi mdi-download me-1" />
            Download PDF
          </Button>
        </div>
      </CardBody>
    </Card>
  )
}
